"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _interactions = _interopRequireDefault(require("./interactions"));

var _usage = _interopRequireDefault(require("./usage"));

var _reducer = _interopRequireDefault(require("settings-ui-sdk/SingleSignOn/reducer"));

var _reducer2 = _interopRequireDefault(require("settings-ui-sdk/TwoFactorAuth/reducer"));

var _reducer3 = _interopRequireDefault(require("settings-ui-sdk/UnifiedBranding/reducer"));

var _reducer4 = _interopRequireDefault(require("settings-ui-sdk/Jita/reducer"));

var _default = (0, _redux.combineReducers)({
  interactions: _interactions.default,
  usage: _usage.default,
  branding: _reducer3.default,
  singleSignOn: _reducer.default,
  twoFactorAuth: _reducer2.default,
  jita: _reducer4.default
});

exports.default = _default;
module.exports = exports.default;